<!--
  Component: Description

  This component creates a plain div of text, classed with 'description'
  for CSS formatting.

  Notes:
  - The text uses MetadataDescMixin behavior, allowing slotting of desc_values
  - HTML-formatted text values are allowed
    - WARNING: This is not safe for unvalidated text.  Use DescriptionSafe
      instead to disable allowing HTML-formatting
  - Also has FallbackText behavior - if value is N/A or missing and fallback NA
      or missing text is present, the fallback text will be displayed instead
-->
<template>
  <div class="description" v-html="dispOrFallbackText"></div>
</template>

<script>
import Component, { mixins } from 'vue-class-component'

import { MetadataDescMixin, MetadataFallbackTextMixin } from './metadata-mixin'

@Component({
})
export default class Description extends mixins(MetadataDescMixin, MetadataFallbackTextMixin) {
  /* Getters */
  get dispOrFallbackText () {
    return this.useFallbackText ? this.fallbackText : this.descDisplayText
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sqs/2018/tab-mods/Description.vue